module.exports = __webpack_public_path__ + "5d8a4e52f28df45a8a3418cd562945c8.svg";